import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const journeysWordList = [
  "adventure",
  "border",
  "bridge",
  "coast",
  "compass",
  "current",
  "depth",
  "desert",
  "discovery",
  "dock",
  "echo",
  "fork",
  "guide",
  "journey",
  "map",
  "marsh",
  "mountain",
  "ocean",
  "origin",
  "pass",
  "path",
  "plain",
  "port",
  "quest",
  "road",
  "sea",
  "shore",
  "space",
  "star",
  "stream",
  "swamp",
  "tide",
  "tunnel",
  "universe",
];

export const journeysCollection: WordCollection = createCollection(
  "journeys",
  "Journeys & Exploration",
  journeysWordList,
  { icon: "map-marker-path", isWordlistViewable: true },
);
